import { useTranslation } from "react-i18next"
import { Button, Label } from "@inkblot-therapy/squid"
import { Icon } from "../Icon"
import { useEffect, useState } from "react"
import { DataBaseService } from "../../services/DatabaseService"
import { transformReferralKeys } from "./ReferralKeyMapper"

type UploadResultProps = {
  clientData: Record<string, any>
}

export const ReferralReviewTable = ({ clientData }: UploadResultProps) => {
  const { t } = useTranslation()
  const [transformedData, setTransformedData] = useState<
    Record<string, any> | undefined
  >()

  useEffect(() => {
    async function getFormats() {
      const response = await DataBaseService.getFormQuestionFormat()
      setTransformedData(transformReferralKeys(response, clientData))
    }
    getFormats()
  }, [clientData])

  const formatValue = (value: any) => {
    if (Array.isArray(value)) {
      return value.length ? value.join(", ") : "-"
    }
    if (value === null || value === undefined || value === "") {
      return "-"
    }
    return value.toString()
  }

  const renderRow = ([key, value]: [string, any]) => (
    <tr key={key} className="border p-7">
      <th className="text-left text-sm text-gray-700 border p-5 w-80">
        <Label>{key}</Label>
      </th>
      <td className="text-gray-900 p-5">
        <Label className="font-medium">{formatValue(value)}</Label>
      </td>
    </tr>
  )

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }

  return (
    <>
      <div className="block">
        <table className="table-auto w-full border">
          <tbody>{Object.entries(transformedData ?? {}).map(renderRow)}</tbody>
        </table>
      </div>
      <div className="mt-5 flex justify-end">
        <Button variant="outlined" onClick={handleBackToTop}>
          <div className="flex gap-2 p-2">
            <Icon variant="ArrowUp" className="mr-1" />
            {t("client.buttons.backToTop")}
          </div>
        </Button>
      </div>
    </>
  )
}
